import React from 'react';

const Button = ({ onClick, children, className, icon, position = 'end', type = 'button' }) => {
  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center transition-all duration-200 ${className}`}
      onClick={onClick}
    >
      {icon && position === "start" && <span className="mr-2 flex-shrink-0">{icon}</span>}
      {children}
      {icon && position === "end" && <span className="ml-2 flex-shrink-0">{icon}</span>}
    </button>
  );
};

export default Button;
